<!-- Renders the rotating homepage community background images behind the hero. -->
<template>
	<div class="absolute pin w-full h-full bg-gray900">
		<template v-for="(community, index) in communities" :key="index">
			<transition name="community-background">
				<div
					v-show="index === communityIndex"
					class="absolute pin w-full h-full bg-cover opacity-25" 
					:style="`background-image: url('${ community.image }');`">
				</div>
			</transition>
		</template>
	</div>
</template>

<script>
export default {
	emits: [],
	props: {
		communities: {
			type: Array,
			default: () => []
		},
		communityIndex: {
			type: Number,
			default: 0
		}
	}
};
</script>
